import { NgModule } from '@angular/core'
import { TrmRepositoriesAndUploadsFeatureService } from './trm-repositories-and-uploads-feature.service'

@NgModule({
  providers: [TrmRepositoriesAndUploadsFeatureService],
})
export class TrmRepositoriesAndUploadsFeatureModule {}
